module.exports = __webpack_public_path__ + "media/recipes/134-3099c528.png";